// Mirrors trpc.purchaseOrders outputs (apps/web/src/api/trpc/routers/purchase-orders.ts)
// and trpc.marketplace.listPurchaseOrders.

export type OrderStatus = "draft" | "sent" | "partially_received" | "received" | "cancelled";

export type OrderSummary = {
  id: number;
  order_number: number;
  supplier_id: number | null;
  supplier_name: string | null;
  reference: string | null;
  status: OrderStatus;
  ordered_at: string;
  expected_at: string | null;
  total: number;
  has_document: boolean;
  line_count: number;
  item_names: string[] | null;
  draft_receipt_id: number | null;
};

export type OrderLine = {
  id: number;
  supplier_item_id: number | null;
  stock_item_id: number;
  stock_item_name: string;
  base_unit: string;
  description: string | null;
  supplier_code: string | null;
  quantity: number;
  unit: string;
  unit_price: number;
  line_total: number;
  received_qty: number;
  outstanding_qty: number;
};

export type Order = Omit<OrderSummary, "has_document" | "line_count" | "item_names" | "draft_receipt_id"> & {
  guid: string;
  supplier_email: string | null;
  supplier_phone: string | null;
  notes: string | null;
  document_key: string | null;
  sent_at: string | null;
  lines: OrderLine[];
  receipts: { id: number; reference: string | null; received_at: string; status: "draft" | "posted"; total: number }[];
};

export type MarketplaceOrder = {
  id: number;
  guid: string;
  status: string;
  amount: number;
  notes: string | null;
  display_id: number | null;
  created_at: string | null;
  seller_id: number;
  seller_name: string;
  items: { id: number; product_id: number; quantity: number; price: number; name: string | null }[];
};

/** A new order pre-filled from a scan or the shopping list. */
export type OrderDraft = {
  supplier_id: number | null;
  reference: string | null;
  expected_at: string | null;
  document_key: string | null;
  lines: {
    supplier_item_id: number | null;
    stock_item_id: number | null;
    description: string;
    supplier_code: string | null;
    quantity: number;
    unit: string;
    unit_price: number;
  }[];
};

export const poNumber = (n: number) => `PO-${String(n).padStart(4, "0")}`;
